<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import type { MenuItem } from '@/types/menu';

interface Props {
  item: MenuItem;
  variant?: 'mobile' | 'desktop';
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'desktop'
});

const { t } = useI18n();

const isAvailable = computed(() => props.item.isAvailable ?? props.item.is_available ?? true);

const statusClasses = computed(() => {
  if (props.variant === 'mobile') {
    return isAvailable.value
      ? 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-200'
      : 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-200';
  }

  return isAvailable.value
    ? 'bg-green-100 text-green-800 ring-1 ring-inset ring-green-600/20 dark:bg-green-950 dark:text-green-100'
    : 'bg-red-100 text-red-800 ring-1 ring-inset ring-red-600/20 dark:bg-red-950 dark:text-red-100';
});
</script>

<template>
  <span
    :class="statusClasses"
    class="inline-flex items-center rounded-md px-2 py-1 text-xs font-medium"
  >
    {{ isAvailable ? t('app.views.menu.list.available') : t('app.views.menu.list.unavailable') }}
  </span>
</template>
